import {Credit} from "./Credit";
import {PriorCourseUnit} from "./PriorCourseUnit";

export class Assessment {
    public static STUDENT_ACCEPTED: string = "STUDENT_ACCEPTED";
    public static STUDENT_DECLINED: string = "STUDENT_DECLINED";
    public static STUDENT_NO_RESPONSE: string = "STUDENT_NO_RESPONSE";

    public id: string;
    public status: string;
    public i: string;

    public priorCourseUnits: PriorCourseUnit[];
    public courseCodes: string[];
    public studentAccepted: boolean;
    public collaborators: string[];
    public precedentId: string;
    public precedentStatus: string;
    public createdPrecedentId: string;
    public credits: Credit[];
    public expirableCredit: boolean;
    public offerExpiryOffset: number = 2;
    public beforeExpiry: boolean;

    constructor() {
        this.credits = new Array();
    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/Assessment.ts